var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.group)?_c('div',[_c('GroupViewAvatarCard'),_c('GroupViewGroupInfoCard'),_c('GroupViewFiscalCard',{on:{"refetch-data":_vm.fetchGroup}}),_c('GroupViewCashConfigCard')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }